
export default function FamilySection() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-amber-100 rounded-full mb-6">
            <span className="text-amber-800 font-medium text-sm tracking-wide">DLA CAŁEJ RODZINY</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            Raj dla rodzin z dziećmi
          </h2>
          <div className="w-24 h-1 bg-amber-400 mx-auto mb-8"></div>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Jardín Tecina to idealne miejsce dla rodzin. Oferujemy szeroki wachlarz udogodnień i atrakcji dla dzieci wszystkich grup wiekowych, zapewniając niezapomniane wspomnienia dla całej rodziny.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://i.imgur.com/N24fWeA.jpg" 
              alt="Dzieci w hotelu" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://i.imgur.com/RrhxyHy.jpg" 
              alt="Rodzinne atrakcje" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-full mb-5">
              <i className="ri-team-line text-blue-700 text-2xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Mini Club i Maxi Club</h3>
            <p className="text-stone-600 leading-relaxed">
              Mini Club z strefą wewnętrzną i zewnętrzną dla dzieci oraz Sala Maxi Club dla nastolatków – profesjonalna animacja i programy rozrywkowe dostosowane do różnych grup wiekowych.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full mb-5">
              <i className="ri-water-flash-line text-green-700 text-2xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Basen dla dzieci</h3>
            <p className="text-stone-600 leading-relaxed">
              Dedykowane baseny dla najmłodszych z bezpieczną płytką wodą, zjeżdżalniami i strefami zabaw wodnych.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-purple-100 rounded-full mb-5">
              <i className="ri-home-heart-line text-purple-700 text-2xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Pokoje rodzinne</h3>
            <p className="text-stone-600 leading-relaxed">
              Przestronne pokoje i Suites zaprojektowane z myślą o rodzinach – komfort i wygoda dla wszystkich.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-full mb-5">
              <i className="ri-restaurant-line text-orange-700 text-2xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Menu dla dzieci</h3>
            <p className="text-stone-600 leading-relaxed">
              Specjalne menu dostosowane do potrzeb najmłodszych gości – zdrowe i smaczne posiłki, które pokochają dzieci.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-pink-100 rounded-full mb-5">
              <i className="ri-game-line text-pink-700 text-2xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Strefy zabaw</h3>
            <p className="text-stone-600 leading-relaxed">
              Bezpieczne strefy zabaw z huśtawkami, zjeżdżalniami i atrakcjami dla różnych grup wiekowych – zarówno wewnątrz, jak i na świeżym powietrzu.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-5">
              <i className="ri-heart-line text-teal-700 text-2xl"></i>
            </div>
            <h3 className="text-xl font-medium text-stone-800 mb-3">Zajęcia i warsztaty</h3>
            <p className="text-stone-600 leading-relaxed">
              Różnorodne zajęcia edukacyjne i warsztaty kreatywne prowadzone przez profesjonalnych animatorów – dzieci będą zachwycone.
            </p>
          </div>
        </div>

        <div className="mt-12 bg-amber-100 border-2 border-amber-300 rounded-xl p-8">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
              <i className="ri-star-line text-amber-700 text-2xl"></i>
            </div>
            <div>
              <h4 className="text-lg font-medium text-amber-900 mb-2">Niezapomniane rodzinne wakacje</h4>
              <p className="text-amber-800 leading-relaxed">
                W Jardín Tecina każdy członek rodziny znajdzie coś dla siebie. Podczas gdy dzieci cieszą się zabawami i nowymi przyjaźnie, rodzice mogą odpocząć w spa, grać w golfa lub po prostu relaksować się przy basenie. To miejsce, gdzie powstają najpiękniejsze rodzinne wspomnienia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}